<template>
  <section class="table">
    <p
      v-if="!recordsfoundishidden"
      class="table--records"
    >
      Records found {{ data.length }}
    </p>
    
    <div
      v-if="isloading === true"
      class="table--loading"
    >
      <Loading/>
    </div>

    <p
      v-if="
        data.length === 0 
        && isloading === false
      "
      class="table--no-items"
    >
      No items found
    </p>
    
    <table v-if="data.length !== 0">
      <tr class="table--titles">
        <slot name="titles"/>        
      </tr>

      <slot name="row"/>
    </table>
  </section>
</template>

<script>
  import Loading from '../loading/loading.vue'

  export default {
    name: 'Table',    
    props: [
      'recordsfoundishidden',
      'data',
      'isloading'
    ],
    components: {
      Loading
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/mediaQueries.scss";

  .table {
    background-color: var(--white);
    padding: 15px;
    border-radius: 3px;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;

    &--records {
      font-weight: bold;
    }

    &--loading {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    &--no-items {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;

      .ratio {
        max-width: 75px;
      }

      td,
      th {
        text-align: left;
        padding: 8px;
        font-size: 14px;
        vertical-align: middle;

        span,
        p {
          display: inline-block;
        }

        span {
          margin-right: 10px;
          color: lighten(black, 70%);
        }
      }

      th {
        font-weight: bold;
      }

      tr:nth-child(even) {
        background-color: var(--blue-light);
      }

      .table--content {
        height: 30px;
      }

      .table--buttons {
        text-align: right;
      }

      .button-bgcolor {

        span {
          color: var(--white);
        }
      }
    }

    @include media-sm {

      table {

        .table--content {
          height: auto;
        }
      }

      table {
        margin-top: 15px;

        .table--titles {
          display: none;
        }

        thead {
          border: none;
          clip: rect(0 0 0 0);
          height: 1px;
          margin: -1px;
          overflow: hidden;
          padding: 0;
          position: absolute;
          width: 1px;
        }

        td {
          border-bottom: 1px solid lighten(black, 90%);
          display: block;
          text-align: right;
        }

        tr {
          display: block;
          margin-bottom: 15px;
        }

        td::before {
          content: attr(data-label);
          float: left;
          font-weight: bold;
          margin-top: 3px;
        }

        td:last-child {
          border-bottom: 0;
        }
      }
    }
  }
</style>
